// @flow

import * as React from 'react'
import Icons from 'ui/Icons'

type Props = {|
  enabled: boolean,
  onClick?: () => void,
|}

const FormControlsDropdownMenuTrigger: React.AbstractComponent<Props> =
  React.forwardRef(({ enabled, onClick, ...props }: Props, ref) => {
    return (
      <button
        className={`flex m-auto focus:outline-none text-xs px-2 py-2 ${
          enabled
            ? 'text-gray-700 hover:text-gray-700'
            : 'text-gray-400 hover:text-gray-400'
        }`}
        onClick={(e) => {
          if (onClick) {
            e.preventDefault()
            e.stopPropagation()
            onClick()
          }
        }}
        ref={ref}
        {...props}
      >
        <Icons.ChevronDown inheritColor size="4" />
      </button>
    )
  })

export default FormControlsDropdownMenuTrigger
